const updates = [
  { date: '2026-07-29', title: '97视频会员体系更新', desc: '97视频近日调整了会员权益结构，新增多项高级功能，老会员可享受自动升级优惠。' },
  { date: '2026-07-27', title: '丝瓜视频上线全新推荐算法', desc: '丝瓜视频宣布升级内容推荐引擎，据官方介绍新算法将使内容匹配精准度提升显著。' },
  { date: '2026-07-25', title: '蓝莓视频独家内容库扩容', desc: '蓝莓视频本月新增大量独家内容，涵盖多个热门分类，进一步巩固其差异化竞争优势。' },
  { date: '2026-07-22', title: '91在线视频优化访问体验', desc: '91在线视频针对部分地区用户反馈的访问问题进行了技术优化，稳定性有所改善。' },
  { date: '2026-07-20', title: '糖心视频社区功能升级', desc: '糖心视频新版增加了互动社区模块，用户可以在平台内分享观影心得与推荐内容。' },
  { date: '2026-07-18', title: '黑桃视频推出新用户专享活动', desc: '黑桃视频为新注册用户推出限时体验活动，新用户可享受多日免费高级内容体验。' },
  { date: '2026-07-15', title: '多平台比价功能筹备中', desc: '榴莲视频即将上线多平台会员费用横向对比功能，帮助用户更直观地做出选择。' },
  { date: '2026-07-12', title: '暑期观影热度持续攀升', desc: '进入暑期以来，各在线视频平台活跃度均有明显提升，97视频与丝瓜视频增长最为显著。' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            最新动态
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            最新动态追踪
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            实时追踪在线视频平台的最新变化与重要更新
          </p>
        </div>
        <div className="max-w-2xl mx-auto relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-200"></div>
          {updates.map((item, i) => (
            <div key={i} className="relative flex gap-6 pb-6 last:pb-0">
              <div className="relative z-10 flex-shrink-0 w-10 h-10 rounded-full bg-background-50 border-2 border-primary-200 flex items-center justify-center">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              </div>
              <div className="flex-1 min-w-0 pt-1">
                <span className="text-[11px] text-foreground-400 font-medium whitespace-nowrap">
                  {item.date}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mt-0.5 font-heading">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}